<template>
    <div class="composer-tabs-trigger" v-bind:class="{active: active == name}" @click="handleClick(name)">
        <slot />
    </div>
</template>

<style>
    .composer-tabs-trigger {
        @apply .flex-grow .px-4 .py-6 .cursor-pointer .text-sm .text-center;

        background: #E8E8E8;
        border-bottom: 1px solid #D3D3D3;
        border-right: 1px solid #D3D3D3;
    }

    .composer-tabs-trigger.active {
        background: #f4f4f4;

        border-bottom-color: transparent;
    }

    .composer-tabs-trigger i {
        @apply .pr-2;
    }
</style>

<script>
export default {
    props: {
        handleClick: Function,
        name: String,
        active: String
    }
}
</script>



// WEBPACK FOOTER //
// src/components/composer/Tabs/TabsTrigger.vue